var React = require('react');

function RssFeed (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"rss_feed_24px"},React.createElement("path",{"id":"icon/communication/rss_feed_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M2.63745 2.63751V4.40626C7.0312 4.40626 10.5937 7.96876 10.5937 12.3625H12.3625C12.3625 6.99376 8.0062 2.63751 2.63745 2.63751ZM3.99995 9.63751C3.24746 9.63751 2.63745 10.2475 2.63745 11C2.63745 11.7525 3.24746 12.3625 3.99995 12.3625C4.75244 12.3625 5.36245 11.7525 5.36245 11C5.36245 10.2475 4.75244 9.63751 3.99995 9.63751ZM2.63745 7.94377V6.17502C6.0562 6.17502 8.82495 8.94377 8.82495 12.3625H7.0562C7.0562 9.92502 5.07495 7.94377 2.63745 7.94377Z","fill":"currentColor"})));
}

RssFeed.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = RssFeed;

RssFeed.default = RssFeed;
